<template>
  <div>
    <Panel
      :module="boardName"
      layout="large"
      :showFilter="false"
      :showSearch="false"
      :showButtons="false"
    >
      <div slot="content-main">
        <br>
        <div class="planner-kanban-filters">
          <FilterQuery :filters="filters" v-model="activeFilters" />
        </div>
        <KanbanBoard :stringFilter="activeFilters" />
      </div>
    </Panel>
  </div>
</template>

<script>
import Panel from "@/ui/layout/Panel";
import FilterQuery from "@/ui/shared/filter-builder/FilterQuery.vue";

import KanbanBoard from "../components/kanban/KanbanBoard.vue";

import { mapMutations } from "vuex";

export default {
  name: "PlannerKanban",
  components: { Panel, FilterQuery, KanbanBoard },
  data() {
    return {
      boardName: this.$route.params.name,
      activeFilters: [],
      filters: [
        {
          type: "date",
          title: "Data Cadastro",
          field: "RegisteredDate",
          value: "",
        },
        {
          type: "multiOptions",
          title: "Cliente",
          field: "CustomerName",
          url: "/api/v1/crm/customer/select-all-without-document",
          propsParams: {},
          value: "",
        },
        {
          type: "multiOptions",
          title: "Etapa",
          field: "StepName",
          url: "/api/v1/planner/step/select-all",
          propsParams: { any: this.$route.params.id },
          value: "",
        },
        {
          type: "listOptions",
          title: "Status Tarefa",
          listName: "ListStatusJob",
          field: "Status",
          options: [
            { text: "Concluída", value: "Concluída" },
            { text: "Hoje", value: "Hoje" },
            { text: "Pendente", value: "Pendente" },
            { text: "Prazo", value: "Prazo" },
          ],
          value: [],
        },
        {
          type: "listOptions",
          title: "Tag",
          listName: "ListTag",
          field: "Name",
          url: "/api/v1/planner/tag/select-all",
          value: "",
        },
      ],
    };
  },
  mounted() {
    this.removeLoading(["panel"]);
  },
  methods: {
    ...mapMutations("generic", ["removeLoading"]),
  },
};
</script>

<style scoped>
.planner-kanban-filters {
  margin-bottom: 16px;
}
</style>

